import Header from "../components/Header";
import "../assets/css/Terms.css"

export default function Terms() {
    return (<>
            <Header/>
            <div className="container section terms">

                <h1>قوانین و مقررات عمومی استفاده از بازی‌ها</h1>

                <p>
                    استفاده از برنامه‌های این توسعه‌دهنده، به معنای پذیرش کامل مفاد این «قوانین و مقررات» است.
                    هدف ما فراهم آوردن محیطی ایمن، سالم، و مسئولانه برای تمامی کاربران است.
                    لطفاً پیش از استفاده، مفاد زیر را با دقت مطالعه نمایید.
                </p>


                <h2>۱- شرایط عضویت و استفاده</h2>
                <ul>
                    <li>عضویت در برنامه‌ها برای افراد بالای ۱۳ سال مجاز است. کاربران زیر این سن تنها با رضایت ولی قانونی
                        خود
                        می‌توانند ثبت‌نام کنند.
                    </li>
                    <li>برای برنامه‌هایی که نیازمند ثبت‌نام هستند، ثبت‌نام با اطلاعات واقعی، صحیح و به‌روز الزامی است.
                    </li>
                    <li>ایجاد حساب‌های کاربری جعلی، تکراری، یا منتسب به دیگران ممنوع است.</li>
                    <li>مسئولیت حفاظت از اطلاعات حساب (رمز عبور و ...) بر عهده کاربر است.</li>
                </ul>


                <h2>۲- مسئولیت کاربران و نحوه رفتار</h2>
                <p>کاربران موظف‌اند از انتشار یا ارسال هرگونه محتوای زیر خودداری کنند:</p>
                <ul>
                    <li>محتوای غیراخلاقی، مستهجن، خشونت‌آمیز یا آزاردهنده</li>
                    <li>توهین، افترا، تهدید یا تمسخر دیگران</li>
                    <li>تبلیغات غیرمجاز یا ارسال اسپم</li>
                    <li>انتشار شایعه، اخبار کذب یا اطلاعات گمراه‌کننده</li>
                    <li>مطالب نژادپرستانه، قومیتی یا تحریک‌آمیز</li>
                    <li>انتشار محتوای نقض‌کننده قوانین کشور یا مالکیت معنوی دیگران</li>
                    <li>هرگونه محتوای ضد دین یا حاکمیت رسمی کشور</li>
                    <li>تهدید و ارعاب کاربران یا معرفی خود به‌جای فردی دیگر</li>
                    <li>تغییر، شبیه‌سازی یا هک محصول</li>
                    <li>ذخیره یا تخریب محتوای برنامه‌ها مانند پروفایل‌ها و تصاویر</li>
                    <li>کپی، اصلاح، ترجمه یا فروش هر نوع محتوای مربوط به بازی‌های توسعه‌دهنده</li>
                </ul>
                <p>هرگونه سوءاستفاده از امکانات برنامه برای فریب، تهدید یا آزار دیگران ممنوع است.</p>


                <h2>۳- قوانین بازی‌های نقش مخفی و سوشال</h2>
                <ul>
                    <li>انتخاب نام نامناسب می‌تواند منجر به مسدود شدن دائمی حساب شود.</li>
                    <li>هرگونه بی‌احترامی و توهین به سایر بازیکنان تخلف محسوب می‌شود.</li>
                    <li>توهین به هر قومیت یا مذهب، منجر به بن دائم خواهد شد.</li>
                    <li>این بازی‌ها برای افراد بالای ۱۸ سال طراحی شده‌اند؛ استفاده زیر این سن مجاز نیست.</li>
                    <li>بحث‌های سیاسی در بازی ممنوع است و با متخلفان برخورد می‌شود.</li>
                    <li>تمامی تصاویر و صداهای بازی‌ها متعلق به استودیو مدریک هستند و استفاده بدون اجازه پیگرد قانونی
                        دارد.
                    </li>
                    <li>قسم خوردن یا قسم دادن دیگران از موارد تخلف است.</li>
                    <li>اطلاق نقش به خود یا دیگران ممنوع است و جریمه به همراه دارد.</li>
                    <li>هر فرد فقط مجاز به داشتن یک حساب کاربری است.</li>
                    <li>شمارهٔ تماس فقط برای شناسایی، ورود و جلوگیری از ساخت اکانت تکراری استفاده می‌شود.</li>
                    <li>هرگونه لابی کردن یا تقلب در بازی موجب مسدود شدن حساب می‌شود.</li>
                </ul>


                <h2>۴- ارتباط و تعامل کاربران</h2>
                <ul>
                    <li>پیام‌رسانی باید با رعایت احترام و قوانین کشور انجام شود.</li>
                    <li>ارسال پیام‌های نامناسب، درخواست اطلاعات شخصی یا اعمال نفوذ ممنوع است.</li>
                    <li>در صورت تخلف، از ابزار گزارش داخلی برای اطلاع به پشتیبانی استفاده کنید.</li>
                </ul>


                <h2>۵- مسئولیت‌های توسعه‌دهنده</h2>
                <ul>
                    <li>توسعه‌دهنده تمام تلاش خود را برای ایجاد محیطی ایمن انجام می‌دهد.</li>
                    <li>مسئولیت محتوای تولیدشده توسط کاربران بر عهده خودشان است.</li>
                    <li>توسعه‌دهنده می‌تواند دسترسی متخلفان را محدود یا حساب آنان را مسدود کند.</li>
                    <li>در صورت به‌روزرسانی قوانین، ادامه استفاده از برنامه به‌منزله پذیرش نسخه جدید است.</li>
                </ul>


                <h2>۶- حریم خصوصی</h2>
                <ul>
                    <li>اطلاعات شخصی کاربران محرمانه تلقی شده و محافظت خواهد شد.</li>
                    <li>اطلاعات ورود و شماره تماس بدون رضایت منتشر نمی‌شود، مگر به حکم مراجع قانونی.</li>
                    <li>در صورت بی‌احتیاطی کاربر، مسئولیتی بر عهده توسعه‌دهنده نیست.</li>
                    <li>بازی‌ها ممکن است شامل تبلیغات باشند و نوع و محل آن‌ها بدون اخطار قبلی تغییر کند.</li>
                </ul>


                <h2>۷- تخلفات و پیامدها</h2>
                <ul>
                    <li>حذف محتوا</li>
                    <li>محدودیت دسترسی به امکانات</li>
                    <li>تعلیق یا حذف دائمی حساب</li>
                    <li>پیگیری قانونی (در صورت لزوم)</li>
                </ul>
            </div>
        </>);
}
